import { render, staticRenderFns } from "./productHistoryPro.vue?vue&type=template&id=3ae1f534&"
import script from "./productHistoryPro.vue?vue&type=script&lang=js&"
export * from "./productHistoryPro.vue?vue&type=script&lang=js&"
import style0 from "./productHistoryPro.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports